import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE,
  WIZ_PHYSIC_POSITION, VALUE_SPACE, VALUE_ENTER, VALUE_DELETE } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  PopUpManager,
  WizBaseComponent,
  WizPopUp,
  WizTextInput,
  WizEvent, WizEventManager,
  WizValidatorFn,
  WizValidationErrors,
  WizValidationError,
  WizValidationContainerDirective
} from '@wizeoo/akm-component-lib';
import { FeiKeyDef, FIELD_KIND, WizConstants } from '@wizeoo/akm-compute-lib';

import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { PopUtils } from '../../../../framework/components/pop/pop-utils';
import { Model } from '../../../../model/model';
import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { ChronocodeVO } from '../../../../vo/core/chronocode.vo';
import { FreeDataVO } from '../../../../vo/core/freedata.vo';
import { FreedataArgsVO } from  '../../../../vo/core/freedataargs.vo';
import { FormDropExtendedFreedataPop } from './form-drop-extended-freedata.pop';
import { FormDropExtendedChronocodePop } from './form-drop-extended-chronocode.pop';
import { IForm } from '../../../../manager/widgets/i-form';
import { ViewData } from '../../../../model/view.data';
import { PivotCellCrosskeyEditPop } from '../../../widgets/pivot/renderers/cells/pivot-cell-crosskey-edit.pop';
import { WIDGET_GLOBAL_KIND } from '../../../../model/enums';
import { PivotCellEditPopData } from '../../../../manager/widgets/i-widget';
/**
 * rendu d'un champ key / filterKey dans les formulaires de baselines
 */
@Component({
  selector: 'form-drop-extended-renderer',
  templateUrl: './form-drop-extended.renderer.html',
  styleUrls: ['./form-drop-extended.renderer.scss'],
})
export class FormDropExtendedRenderer extends WizBaseComponent implements AfterViewInit, OnDestroy, IWizItemRenderer<null, FormFieldObj> {
  @HostBinding('style.width') elwidth: string = '100%';
  @ViewChild('content', { read: WizTextInput }) content: WizTextInput;

  /** Zone de validation des champs de saisie */
  @ViewChild('container', { read: WizValidationContainerDirective, static: false }) validationContainer: WizValidationContainerDirective;


  constructor(public cdref: ChangeDetectorRef, public elementRef: ElementRef, public  renderer: Renderer2) {
    super(cdref,elementRef, renderer)
  }

  public fkd: FeiKeyDef; // la définition de la clé
  public currentValue: string = null; // valeur en cours pour le composant

  owner: null;

  public get model(): Model {
    return this.data.widget?.model || this.data.model;
  }

  private _data: FormFieldObj;
  @Input() public set data(value: FormFieldObj) {
    this._data = value;
    this.fkd = value?.fkd;


    if(value?.freedataMode) {
      let clone: FreedataValueVO = this.data.clone;
      let arg: FreedataArgsVO = this.data.arg;
      this.currentValue = clone.argsObjVO[arg.code];
    } else {
      this.currentValue = (this.data?.widget as IForm)?.keyPartMap?.get(this.fkd?.fullCode); // mise à jour de la valeur en cours
    }

    if(!!this.content) { // seulement si instancié
      this.feed();
    }
  }

  public get data(): FormFieldObj {
    return this._data;
  }

  // display or not of the label
  _wizShowLabel: boolean = true;
  @Input()
  public set wizShowLabel(v: boolean) {
    this._wizShowLabel = v;
    this.cdref.markForCheck();
  }
  public get wizShowLabel(): boolean {
    return this._wizShowLabel;
  }


  /** affichage du clean */
  public isCleanEnable():boolean {

    if(this.data?.freedataMode) {
      return !this.wizDisabled && this.content?.wizValue;
    } else {
      return this.fkd?.isFilterKey && !this.wizDisabled && this.content?.wizValue;
    }
  }



  public getRightIcon():any {
    if(this.wizDisabled) {
      return null;
    }
    // if(!!this.isCleanEnable()) {
    //   return null;
    // }
    return 'arrow-down';
  }


  ngAfterViewInit() {
    // console.log('filter', this.data);
    this.feed();
    this.addlisteners();
  }

  private addlisteners(): void {
    WizEventManager.addListener(this, this.elementRef, 'click', this.showHidePop); // demande d'ouverture de pop
    // WizEventManager.addListener(this, this.elementRef, WIZ_EVENT_TYPE.INPUT_RIGHT_CLICK, this.showHidePop); // demande d'ouverture de pop
    WizEventManager.addListener(this, this.elementRef, 'keydown', (e: KeyboardEvent) => this.onKeyDown(e));
    //WizEventManager.addListener(this, this.elementRef, WIZ_EVENT_TYPE.CLEAR, this.clear); // clic sur la croix de suppression
  }

  ngOnDestroy(): void {
    WizEventManager.removeListener(this, this.elementRef, 'click'); // demande d'ouverture de pop
    // WizEventManager.removeListener(this, this.elementRef, WIZ_EVENT_TYPE.INPUT_RIGHT_CLICK); // demande d'ouverture de pop
    WizEventManager.removeListener(this, this.elementRef, 'keydown');
  }



  /**
   * Ecouteur sur key down pour check clavier
   * @param event Evènement key down
   */
  private onKeyDown(event: KeyboardEvent): void {
    if(this.wizDisabled) { // pas si disabled
      return;
    }
    // ouverture sur enter / space
    if (event.key === VALUE_SPACE || event.key === VALUE_ENTER) {
      this.showHidePop();
    }

    // delete par suppr
    if (event.key === VALUE_DELETE && this.isCleanEnable()) {
      this.clear();
    }
  }

  /** delete par la croix */
  private clear(e: any = null): void {
    this.content.wizValue = null;
    this.currentValue = null;
    
    if(this.data.freedataMode) {
      let clone: FreedataValueVO = this.data.clone;
      let arg: FreedataArgsVO = this.data.arg;
      this.model.freedataEngine.feedFreedataValueField(clone, arg.code, null );
    }

    WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this, this.data));
  }


  private feed(): void {
    if (!this.data) {
      return;
    }

    this.content.wizLabel = this.data.label;
    
    if(this.data.freedataMode) { // mode FDV

      let realVal: string = null;
      try {
        let clone: FreedataValueVO = this.data.clone;
        let arg: FreedataArgsVO = this.data.arg;
        let rawVal: string = clone.argsObjVO[arg.code];
        
        if(arg.code === WizConstants.FIELD_PARENT_CODE) { // gestion du code parent
          realVal = rawVal; // rien à faire
        } else if(rawVal) {
          let fdCode: string = rawVal.split(WizConstants.CONTEXT_SEPARATOR)[0];
          let fdvCode: string = rawVal.split(WizConstants.CONTEXT_SEPARATOR)[1];
          let realFD: FreeDataVO = this.model.freedataEngine.getFreeData(fdCode);
          let realFDV: FreedataValueVO = realFD.getFreeDataValue(fdvCode);
          if(this.data.wcio.subField) {
            realVal = realFDV.argsObjVO[this.data.wcio.subField];
          } else {
            realVal = realFDV.argsObjVO[WizConstants.FIELD_LABEL];
          }
        }
      } catch(e: any) {
        // console.log('oups FormDropExtendedRenderer', e);
      }
      this.content.wizValue = realVal; // on prend le libellé
    } else { // mode Baseline
      // let rawVal: string = this.data.widget?.keyPartMap?.get(this.fkd.fullCode); // les données sont calculées par le formWidget
      // this.currentValue = rawVal; // mise à jour de la valeur en cours
      const field: string = this.data.wcio?.fdvf ? this.data.wcio?.fdvf : WizConstants.FIELD_LABEL;
      // const subArg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(this.pkd.code, field);
      
      let rawVal: string = this.currentValue;
      // ici prise en compte des chronos
      // console.log('rawVal', rawVal, field, this.fkd);

      // TODO ici

      if (!!rawVal) { // collecte du FreedataValue
        if(this.fkd.isFreedata) {
          const freedataValue: FreedataValueVO = this.model.freedataEngine.getFreedataValue(this.fkd.code, rawVal);
          rawVal = freedataValue?.argsObjVO[field]; // la valeur du champ pour ce FD 
        } else if(this.fkd.isChrono) {
          const chrono: ChronocodeVO = this.model.chronocodeEngine.getChronocode(rawVal);
          // TODO prise en compte des autres champs possibles
          rawVal = chrono?.trsLabel;
        } else { // mesure de type filter
          //console.log('from measure', this.currentValue);
      
          if(this.fkd.isMeasure && this.fkd.measure.dataKind === FIELD_KIND.FILTER) { // mesure de type filter
              try {
                let FDCode: string = (this.fkd.measure.settings as any).keys[0].FD;
                let FDVCode: string = this.currentValue;
                if(FDCode && FDVCode) {
                  let renderField: string = (this.fkd.measure.settings as any).keys[0].render || ViewData.FIELD_LABEL;
                  let fdv: FreedataValueVO = this.model.freedataEngine.getFreedataValue(FDCode, FDVCode);
                  if(!!fdv) {
                    rawVal = this.model.freedataEngine.getFDValue(fdv, renderField);
                  }
                  //console.log('fdv', fdv, rawVal);
                }
              } catch (e:any) {
                //console.log("force DDExt on filter oups", e);     
              }
            
            
            // console.log('from measure', value);
          } else if (this.fkd.isMeasure && this.fkd.measure.dataKind === FIELD_KIND.CROSS_FILTER) {
            // rien à faire, rawValue c'est OK //console.log("TODO TODO force DDExt on cross filter oups");     
          }
        }
      } 
      this.content.wizValue = rawVal; // on prend le libellé
    }

    this.checkError();
    this.cdref.markForCheck();
  }

  public showHidePop(e:any = null): void {
    if(!!this.wizDisabled) {
      return;
    }
    

    let popClass: any = FormDropExtendedFreedataPop;
    let datas: any = [this.data, this.currentValue, this.backFromFilterPop.bind(this)];

    if(this.fkd?.isChrono) {
      popClass = FormDropExtendedChronocodePop;
    } else if(this.fkd?.isMeasure && this.fkd.datakind === FIELD_KIND.CROSS_FILTER) {
      popClass = PivotCellCrosskeyEditPop;
      datas = {
        kind: WIDGET_GLOBAL_KIND.BASELINE,
        title: "bob",
        label: "bill",
        fkd: this.data.fkd,
        column: null,
        line: this.data.widgetLine,
        widget: this.data.widget,
        value: this.currentValue,
        callback: this.backFromFilterPop.bind(this)
      }
    }




    const choosePop: WizPopUp = new WizPopUp(
      popClass,
      false,
      false,
      null,
      '400px',
      '350px',
      datas
    );
    const pos: DOMRect = this.elementRef.nativeElement.getBoundingClientRect();

    const bestXY: [number, number] = PopUtils.setPopCoord(pos, choosePop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    choosePop.customPosition = targetPosition;

    if (PopUpManager.exist(choosePop)) { // suppression de l'instance existante
      choosePop.hide();
    }
    // ouverture de la pop.
    choosePop.show();
  }

  /** la mise à jour est directe depuis la popUp */
  private backFromFilterPop(value: any): void {
    
    if(this.data.freedataMode) {
      let clone: FreedataValueVO = this.data.clone;
      let arg: FreedataArgsVO = this.data.arg;
      let fullValue: string = null;
      if(value) {
        if(arg.code === WizConstants.FIELD_PARENT_CODE) {
          fullValue = value; // rien à faire, c'est déjà le code parent
        } else {
          fullValue = [arg.datas.split(WizConstants.CONTEXT_SEPARATOR)[0], value].join(WizConstants.CONTEXT_SEPARATOR);
        }
        
      }
      this.model.freedataEngine.feedFreedataValueField(clone, arg.code, fullValue );
      // console.log('backFromFilterPop', clone, clone.argsObjVO[fullValue]);
    } else if(this.data.fkd?.datakind === FIELD_KIND.CROSS_FILTER) {
      this.currentValue = (value as PivotCellEditPopData).updates.value;          
    } else {
      // console.log('backFromFilterPop', value);
      this.currentValue = value;
    }
    this.feed();
    // pour transmission au ffRenderer
    WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this, this.data));
  }


  /** contrôle de la présence de saisie invalide suite à la modif d'une autre mesure */
  private checkError(): void {
    let errors = this.validationContainer.check(!!this.content?.wizValue, true);
  }

  /** 
   * controle de cohérence de la value saisie 
   * (fonctions de contrôle sur codifs) 
   * appelé depuis les composants
   */
  public checkValueAvailable(): WizValidatorFn { 
    return (): WizValidationErrors | null => {

      if(!!this.data?.arg) {
        const neoExp = this.data.arg.validator;
        let result: boolean = this.model.freedataFormulaCoreEngine.checkFreedataExp(this.data.clone, neoExp, this.data?.widget?.fei);
        if (!result) {
          // console.log('arg Error', this.data.arg.trsValueControlMessage);
          const temp: WizValidationError = {
            wizError: this.data.arg.trsValueControlMessage, // '$.common.error.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }


      return null;
    }
  }


}
